import { Injectable, signal } from '@angular/core';

/**
 * Light/dark theme state. Owns the single source of truth for which theme is
 * active (the `light-theme` / `dark-theme` class on <body>) so the header user
 * menu can both read the current theme and flip it, and any screen can react.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  /** True when the dark theme is active. */
  readonly isDark = signal(false);

  /** Apply the initial theme from the OS preference (called once on startup). */
  initFromSystem(): void {
    this.set(window.matchMedia('(prefers-color-scheme: dark)').matches);
  }

  /** Flip between light and dark. */
  toggle(): void {
    this.set(!this.isDark());
  }

  /** Set the theme explicitly and sync the <body> class. */
  set(isDark: boolean): void {
    const classList = document.body.classList;
    classList.remove('light-theme', 'dark-theme');
    classList.add(isDark ? 'dark-theme' : 'light-theme');
    this.isDark.set(isDark);
  }
}
